import type { LilliSettings } from "@/getSettings";

export default {
  termsAndConditionsLink: "http://learningapps.technology/?page_id=1493",
  privacyPolicyLink: "http://learningapps.technology/?page_id=1496",
  headerlogo: "/img/logo.png",
  showDetailsForQuiz: false,
  showDetailsForSurvey: false,
  showSeal: false,
  showCovidView: false,
  showCovidCertificatesToAdmin: false,
  title: "learningapps",
  qGateFields: [
    { id: "birthdate", type: "date", label: "birthday", mandatory: true },
    { id: "birthplace", type: "string", label: "birthplace", mandatory: true },
    // NOTE: nationalityWithNonEuVisa also adds the additional, optional fields socialSecurity and workPermit (if the user is not from the EU)
    {
      id: "nationality",
      type: "nationalityWithNonEuVisa",
      label: "nationality",
      mandatory: true,
    },
    { id: "address", type: "string", label: "address", mandatory: true },
    { id: "city", type: "string", label: "city", mandatory: true },
    { id: "zipCode", type: "string", label: "zipCode", mandatory: true },
    { id: "country", type: "country", label: "country", mandatory: true },
    {
      id: "car",
      type: "switchString",
      label: "car",
      mandatory: false,
      settings: { subLabel: "carPlate", subId: "carPlate" },
    },
  ],
  supportedLanguages: [
    "de",
    "en",
    "bg",
    "cs",
    "el",
    "hr",
    "hu",
    "it",
    "lv",
    "pl",
    "pt",
    "ru",
    "ro",
    "es",
    "tr",
  ],
  defaultLanguage: "de",
} satisfies LilliSettings;
